import { ArticleCardGrid as ArticleCardGridNPM } from '@rotaryintl/component-article-card';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const ArticleCardGrid = ({ rendering, params: { ComponentId } = {} }) => (
  <ArticleCardGridNPM id={ComponentId}>
    <Placeholder rendering={rendering} name="articlecard-grid" />
  </ArticleCardGridNPM>
);

export default withSitecoreContext()(ArticleCardGrid);
